/**
 * Entry point applicazione client.
 *
 * Carica i template compilati e registra i Custom Elements.
 * Viene bundlato da scripts/build-app.ts → web/public/js/app.js (IIFE).
 */
import appTemplates from './generated/templates.ts';
import { setTemplates } from './lib/template-parse.ts';
import { enforcePerm } from './lib/perm.ts';
import { initModalAriaFix } from './lib/modal-fix-aria.ts';

import { RicercaLavoratori } from './components/ricerca-lavoratori.ts';
import { RicercaImprese } from './components/ricerca-imprese.ts';
import { DettaglioLavoratore } from './components/dettaglio-lavoratore.ts';
import { DettaglioImpresa } from './components/dettaglio-impresa.ts';
import { PasskeyLogin } from './components/passkey-login.ts';
import { GestionePasskey } from './components/gestione-passkey.ts';
import { CambioPassword } from './components/cambio-password.ts';
import { EditDelega } from './components/edit-delega.ts';
import { ListaDeleghe } from './components/lista-deleghe.ts';
import { DataTable } from './components/data-table.ts';
import { ListaPresentazioni } from './components/lista-presentazioni.ts';
import { DettaglioPresentazione } from './components/dettaglio-presentazione.ts';
import { TabellaDisdette } from './components/tabella-disdette.ts';
import { NuovaDisdetta } from './components/nuova-disdetta.ts';
import { Elaborazioni } from './components/elaborazioni.ts';
import { GestioneUtenti } from './components/gestione-utenti.ts';
import { GestioneLista } from './components/gestione-lista.ts';
import { TabellaLavoratori } from './components/tabella-lavoratori.ts';
import { TabellaImprese } from './components/tabella-imprese.ts';
import { InvioStatini } from './components/invio-statini.ts';
import { ElencoDeleghe } from './components/elenco-deleghe.ts';
import { TemaSelector } from './components/tema-selector.ts';
import { OperatoreCombobox } from './components/operatore-combobox.ts';
import { EditLavoratore } from './components/edit-lavoratore.ts';
import { EditImpresa } from './components/edit-impresa.ts';
import { Archivio } from './components/archivio.ts';
import { ConfrontoSetup } from './components/confronto-setup.ts';
import { GraficoStatistiche } from './components/grafico-statistiche.ts';
import { StatisticheSetup } from './components/statistiche-setup.ts';
import { TabellaConfronto } from './components/tabella-confronto.ts';
import { BackupManager } from './components/backup-manager.ts';
import { RiallineaDeleghe } from './components/riallinea-deleghe.ts';
import { EditDelegaAltroTerritorio } from './components/edit-delega-altro-territorio.ts';
import { TabellaAltriTerritori } from './components/tabella-altri-territori.ts';
import { ElencoTerritori } from './components/elenco-territori.ts';

// --- Init template engine client ---
setTemplates(appTemplates);
initModalAriaFix();

// --- Registrazione componenti ---
RicercaLavoratori.register();
RicercaImprese.register();
DettaglioLavoratore.register();
DettaglioImpresa.register();
PasskeyLogin.register();
GestionePasskey.register();
CambioPassword.register();
EditDelega.register();
DataTable.register();
ListaDeleghe.register();
ListaPresentazioni.register();
DettaglioPresentazione.register();
TabellaDisdette.register();
NuovaDisdetta.register();
Elaborazioni.register();
GestioneUtenti.register();
GestioneLista.register();
TabellaLavoratori.register();
TabellaImprese.register();
InvioStatini.register();
ElencoDeleghe.register();
TemaSelector.register();
OperatoreCombobox.register();
EditLavoratore.register();
EditImpresa.register();
Archivio.register();
ConfrontoSetup.register();
GraficoStatistiche.register();
StatisticheSetup.register();
TabellaConfronto.register();
BackupManager.register();
RiallineaDeleghe.register();
EditDelegaAltroTerritorio.register();
TabellaAltriTerritori.register();
ElencoTerritori.register();

// --- Enforce permessi su markup server-rendered ---
document.addEventListener('DOMContentLoaded', () => enforcePerm());
